import {Component, Input, OnInit} from '@angular/core';
import { Network } from '@ionic-native/network/ngx';
import { ModalController, ToastController, LoadingController, AlertController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SearchCountryField, CountryISO } from 'ngx-intl-tel-input';
import { GlobalVariables } from '../../common/global-variables';
import { ApiService } from '../../services/api/api.service';
import { PrintService } from '../../services/print/print.service';

@Component({
  selector: 'app-product-sale',
  templateUrl: './product-sale.page.html',
  styleUrls: ['./product-sale.page.scss'],
})
export class ProductSalePage implements OnInit {

  @Input() product: any;

  paymentForm: any;
  isOffline: boolean;
  loaderToShow: any;
  vendorSettings: any;
  deviceInfo: any;
  denomination: any;
  transactionCompleted: boolean;
  transactionResponse: any;

  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  //TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [
    CountryISO.Botswana,
    CountryISO.Liberia,
    CountryISO.Namibia,
    CountryISO.Mozambique,
    CountryISO.SouthAfrica,
    CountryISO.Kenya,
    CountryISO.Nigeria,
    CountryISO.Uganda
  ];

  constructor(private modalController: ModalController, public alertController: AlertController,
              private formBuilder: FormBuilder, public loadingController: LoadingController,  public printService: PrintService, public api: ApiService,
              public toastController: ToastController, private network: Network, public globals: GlobalVariables) {
    this.paymentForm = this.formBuilder.group({
        phone: [undefined, [Validators.required]],
        amount: ['', [Validators.required, Validators.min(0)]]
      });

    this.transactionCompleted = false;
    this.transactionResponse = {ok: false};

    this.checkNetwork();

    this.network.onChange().subscribe(status => {
      if (this.network.type === 'none') {
        this.isOffline = true;
        this.presentToast('You\'re now offline', 'danger');
      } else {
        this.isOffline = false;
        this.presentToast('You\'re now connected via: ' + this.network.type, 'success');
      }
    });
  }

  ngOnInit() {
    console.log(this.product);
    if (this.product.denomination) {
      this.denomination = this.product.denomination.split(',');
      // console.log(this.denomination);
    }

    this.vendorSettings = this.globals.vendorSettings;
    this.deviceInfo = this.globals.deviceInfo;
  }

  async purchaseProduct() {
    const serviceURL = this.globals.userInfo.OmniServiceURL + 'productsale';

    const productSale = {
                    product: {
                        ProductID: this.product.productID,
                        ProductCode: this.product.productCode,
                        Country: this.product.country,
                        ProductName: this.product.productName,
                        Supplier: this.product.supplier,
                        Category: this.product.category,
                        Provider: this.product.provider,
                        PaymentType: this.product.paymentType,
                        ServiceURL: this.product.serviceURL
                    },
                    mobileNumber: this.paymentForm.value.phone.nationalNumber,
                    amount: this.paymentForm.value.amount.toString()
                };

    console.log('Product: ', this.product);
    console.log('perform sale', productSale);

    const warningMessage = 'You\'re about to vend ' + this.product.productName + ' for ' +
                    this.vendorSettings.currency + ' ' + this.paymentForm.value.amount + ' on this number: '
                    + this.paymentForm.value.phone.nationalNumber + '.<br/><br/> <strong>Are you sure ?</strong>';

    const alert = await this.alertController.create({
      header: 'Confirm Purchase !',
      message: warningMessage,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            // console.log('Confirm Cancel: blah');
          }
        },
        {
          text: 'Yes, continue',
          cssClass: 'warning',
          handler: () => {
            // Sale Product using OmniService API

            this.showLoader('Processing Product Sale ...');
            /*
            this.transactionResponse = {
                ok: true,
                msg: 'transaction error message',
                data: {
                    transactionID: '1595935399',
                    dateTime: '2020-07-28T13:23:33',
                    requestId: 9660462,
                    serialNumber: '00000000000220942248',
                    amount: '9.00',
                    product: 'MTC N$10 Token',
                    token: '4703804630309008',
                    flatFee: '1.00',
                    mobileNumber: '0798783115',
                    msisdn: null
                }
            };

            this.transactionCompleted = true;
            this.hideLoader();
            */

            this.api.postApiEndpoint(serviceURL, productSale).subscribe( res => {
                console.log(res.data);
                this.transactionResponse = res;
                if (res.ok) {
                    this.presentToast('Product Sold Successfully !', 'success');
                    this.transactionCompleted = true;
                } else {
                    this.presentToast(res.msg.toString(), 'danger');
                }
                this.transactionCompleted = true;
                this.hideLoader();
            });
          }
        }
      ]
    });

    await alert.present();
  }

  selectDenomination(amnt) {
    this.paymentForm.value.amount = Number(amnt);
  }

  async printProductSale(trans) {
    let transString = "";
    transString = "\r\nToken: " + trans.token + "\r\nMobile: " + trans.mobileNumber + "\r\n\r\nProduct: " + trans.product + "\r\nAmount: " + trans.amount + "\r\nFlat Fee: " + trans.flatFee + "\r\nTransaction ID: " + trans.transactionID + "\r\nDate: " + trans.dateTime + "\r\nRequest ID: " + trans.requestId + "\r\nSerial Number: " + trans.serialNumber + "\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n";
    this.printService.print(transString);
  }

  checkNetwork() {
    if (this.network.type === 'none') {
        this.isOffline = true;
        // alert('You\'re now offline');
      } else {
        this.isOffline = false;
        // alert('You\'re now connected via: ' + this.network.type);
      }
  }

  showLoader(displayMessage) {
    this.loaderToShow = this.loadingController.create({
      message: displayMessage
    }).then((res) => {
      res.present();

      res.onDidDismiss().then((dis) => {
        // console.log('Loading dismissed!');
      });
    });
    // this.hideLoader();
  }

  hideLoader() {
    setTimeout(() => {
      this.loadingController.dismiss();
    }, 500);
  }

  async closeModal() {
    const onClosedData = {};
    await this.modalController.dismiss(onClosedData);
  }

  async presentToast(msg, color) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 2000,
      position: 'bottom',
      color
    });
    toast.present();
  }

}

